import NearbyDetail from 'src/components/user-mobile/map/nearby-attraction/NearbyDeatil';
import TopFixedBarNearby from 'src/components/user-mobile/map/nearby-attraction/TopFixedBarNearby';
import styled from 'styled-components';

export default function NearbyDetailPage() {
  return (
    <>
      <TopFixedBarNearby text="주변 관광지" />
      <NearbyContainer>
        <NearbyDetail />
      </NearbyContainer>
    </>
  );
}

const NearbyContainer = styled.div`
  padding-top: 52px;
`;
